import defaultColors from './defaultColors';
import { createCustomTheme } from './themeManager';

const theme = createCustomTheme(defaultColors);

export default theme;
